<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>
    Select {{ utils.getLangTerm('ta-jsa-swms.list.account-title', 'TA/JSA/SWMS Templates') }}
    <span *ngIf="dataSource.selection.selected.length">
      ({{ dataSource.selection.selected.length }})
    </span>
  </h5>

  <button mat-icon-button aria-label="Close dialog" matTooltip="Close this dialog." (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <form class="form-inline my-auto my-xl-0 float-xl-right" (ngSubmit)="dataSource.getData(true)">
    <input class="form-control mr-2 my-1" type="search" [(ngModel)]="dataSource.search" name="search"
      placeholder="Search" aria-label="Search" />

    <button mat-raised-button color="secondary" class="mr-2 mr-xl-3 my-1" type="submit">
      <mat-icon>search</mat-icon> Search
    </button>

    <button mat-raised-button class="mr-2 my-1" (click)="onClearSelected()" type="button">
      Clear Selected
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <table mat-table [dataSource]="dataSource" matSort matSortActive="title" matSortDirection="asc" matSortDisableClear>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        #
      </th>
      <td mat-cell *matCellDef="let ta_revised">
        {{ ta_revised.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="task_name">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        {{ utils.getLangTerm('ta-jsa-swms.fields.task_name.label', 'Name') }}
      </th>
      <td mat-cell *matCellDef="let ta_revised" class="no-padding text-wrap">
        <span>
          {{ ta_revised.task_name | ellipsis: ['30'] }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="task_description">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        {{ utils.getLangTerm('ta-jsa-swms.fields.task_description.label', 'Description') }}
      </th>
      <td mat-cell *matCellDef="let ta_revised" class="no-padding text-wrap">
        <span>
          {{ ta_revised.task_description | ellipsis: ['60'] }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="work_procedure">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        {{ utils.getLangTerm('ta-jsa-swms.fields.work_procedure.label', 'Work Procedure') }}
      </th>
      <td mat-cell *matCellDef="let ta_revised" class="no-padding text-wrap">
        <span>
          {{ ta_revised.work_procedure | ellipsis: ['60'] }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Date Created
      </th>
      <td mat-cell *matCellDef="let ta_revised" class="no-padding text-wrap">
        <span>
          {{ (ta_revised.date_created * 1000) | timezoneConvertMedium }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created_UTC">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Date Created (UTC)
      </th>
      <td mat-cell *matCellDef="let ta_revised" class="no-padding text-wrap">
        <span>
          {{ (ta_revised.date_created * 1000) | timezoneConvertUTCMedium }}
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="dataSource.selection.toggle(row.id)">
    </tr>
  </table>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
  <mat-paginator class="my-2 ml-1 mr-2" [length]="dataSource?.total | async" [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons>
  </mat-paginator>

  <button class="my-2 mx-1" mat-raised-button color="primary" type="button" (click)="onSaveAndClose()"
    [disabled]="!data['multiple'] && !dataSource.selection.hasValue()">
    Select & Close
  </button>
</mat-dialog-actions>